import { render, staticRenderFns } from "./VueRouterWrapper.vue?vue&type=template&id=a2b2d910"
import script from "./VueRouterWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./VueRouterWrapper.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports